import { generatePath, useHistory } from 'react-router-dom'
import { Modal, useModals } from 'almanac-ui/Modal'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowRight, Check2 } from 'blaze-ui/icons/20'
import { NewPostModal } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/NewPostModal/NewPostModal'
import { CAMPAIGNS_PATH, CONTENT_PREFERENCES_PATH } from 'paths'
import Styles from '../AiAvatarAnnouncementModal.module.scss'

interface Props {
  workspaceId: number
  onDone: () => void
}

export const AllSetStep = ({ workspaceId, onDone }: Props) => {
  const history = useHistory()
  const { openModal } = useModals()

  const navigate = (to: Parameters<typeof history.push>[0]) => {
    onDone()
    history.push(to)
  }

  const navItems = [
    {
      title: 'Avatars',
      description: 'Add, edit, or remove avatars',
      onClick: () => navigate({ pathname: generatePath(CONTENT_PREFERENCES_PATH, { workspaceId }), hash: '#avatars' }),
    },
    {
      title: 'Campaigns',
      description: 'See where avatar videos appear',
      onClick: () => navigate({ pathname: generatePath(CAMPAIGNS_PATH, { workspaceId }) }),
    },
    {
      title: 'Create a post',
      description: 'Make a one-off avatar video now',
      onClick: () => {
        onDone()
        openModal(NewPostModal, { initialContentCategory: 'avatar_video' })
      },
    },
  ]

  return (
    <Modal.Root size="md">
      <Modal.Header title="AI avatar videos are on" onClose={onDone} />
      <Modal.Content>
        <div className={Styles.allSetContent}>
          <span className={Styles.checkBadge}>
            <Check2 color="var(--green-50)" />
          </span>
          <Text className={Styles.body}>
            From now on, avatar content will be added to your future campaigns automatically — change your avatars or
            campaigns anytime.
          </Text>
          <div className={Styles.rows}>
            {navItems.map((item) => (
              <button key={item.title} type="button" className={Styles.row} onClick={item.onClick}>
                <span className={Styles.rowText}>
                  <Text fontWeight="500">{item.title}</Text>
                  <Text variant="secondary">{item.description}</Text>
                </span>
                <ArrowRight className={Styles.arrow} />
              </button>
            ))}
          </div>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="right">
          <Button variant="primary" size="lg" onPress={onDone}>
            Done
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
